import { render, staticRenderFns } from "./account-number.vue?vue&type=template&id=53db0433&scoped=true&"
import script from "./account-number.vue?vue&type=script&lang=js&"
export * from "./account-number.vue?vue&type=script&lang=js&"
import style0 from "./account-number.vue?vue&type=style&index=0&id=53db0433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db0433",
  null
  
)

component.options.__file = "account-number.vue"
export default component.exports